import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { config } from "../Custom/RazorPay";
import "../../css/FitnessClasses.css";

// Service definitions with images and metadata
const SERVICES = [
  {
    id: "zumba",
    name: "Zumba",
    priceLabel: "₹19/Month",
    image: require("../../assests/classes/zumba.webp"),
  },
  {
    id: "yoga",
    name: "Yoga",
    priceLabel: "₹19/Month",
    image: require("../../assests/classes/Yoga.webp"),
  },
  {
    id: "hiit",
    name: "HIIT",
    priceLabel: "₹19/Month",
    image: require("../../assests/classes/HIIT.webp"),
  },
  {
    id: "dance",
    name: "Dance",
    priceLabel: "₹19/Month",
    image: require("../../assests/classes/Dance.webp"),
  },
];

class FitnessClasses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedServices: ["hiit"], // default select HIIT like in screenshot
      selectedDuration: 12, // 6 or 12
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    // Fetch dynamic prices from backend database
    this.fetchClassPlans();

    // Check if user just returned after login with a pending checkout
    const pendingCheckout = localStorage.getItem("pending_classes_checkout");
    const userToken = localStorage.getItem("token");

    if (pendingCheckout && userToken) {
      try {
        const parsed = JSON.parse(pendingCheckout);
        if (parsed.services && parsed.duration) {
          this.setState(
            {
              selectedServices: parsed.services,
              selectedDuration: parsed.duration,
            },
            () => {
              localStorage.removeItem("pending_classes_checkout");
              // Open razorpay checkout directly
              this.launchRazorpayCheckout();
            }
          );
        }
      } catch (e) {
        console.error("Error parsing pending checkout:", e);
      }
    }
  }

  // Fetch prices from database
  fetchClassPlans = () => {
    const apiUrl = process.env.REACT_APP_API_URL || "https://d1dgpoid6t01jm.cloudfront.net";
    fetch(`${apiUrl}/user/class-plans`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.response && data.response.plans) {
          this.setState({ dbPlans: data.response.plans });
        }
      })
      .catch((err) => {
        console.log("Using default plan prices:", err.message);
      });
  };

  // Toggle selection for single / multi cards
  toggleService = (serviceId) => {
    this.setState((prevState) => {
      const isSelected = prevState.selectedServices.includes(serviceId);
      let updated;
      if (isSelected) {
        updated = prevState.selectedServices.filter((id) => id !== serviceId);
      } else {
        updated = [...prevState.selectedServices, serviceId];
      }
      return { selectedServices: updated };
    });
  };

  // Pricing calculation (uses dbPlans if loaded from backend, otherwise defaults)
  getPricing = () => {
    const { selectedServices, selectedDuration, dbPlans } = this.state;
    const count = selectedServices.length;
    if (count === 0) {
      return {
        count: 0,
        price6M: 0,
        monthly6M: 0,
        price12M: 0,
        monthly12M: 0,
        strike12M: 0,
        saved12M: 0,
        finalPrice: 0,
      };
    }

    let price6M = 0;
    let monthly6M = 0;
    let price12M = 0;
    let monthly12M = 0;

    if (dbPlans && dbPlans.length > 0) {
      selectedServices.forEach((id) => {
        const p = dbPlans.find((item) => item.service_code === id);
        if (p) {
          const m6 = Math.round(p.six_month_price / (6 * 1.18)) || p.monthly_rate_6m || 30;
          const m12 = Math.round(p.yearly_price / (12 * 1.18)) || p.monthly_rate_12m || 19;
          price6M += p.six_month_price;
          monthly6M += m6;
          price12M += p.yearly_price;
          monthly12M += m12;
        } else {
          price6M += 211;
          monthly6M += 30;
          price12M += 269;
          monthly12M += 19;
        }
      });
    } else {
      price6M = 211 * count;
      monthly6M = 30 * count;
      price12M = 269 * count;
      monthly12M = 19 * count;
    }

    const strike12M = price6M * 2;
    const saved12M = Math.max(0, strike12M - price12M);
    const finalPrice = selectedDuration === 6 ? price6M : price12M;

    return {
      count,
      price6M,
      monthly6M,
      price12M,
      monthly12M,
      strike12M,
      saved12M,
      finalPrice,
    };
  };

  // Check login state: if logged in -> razorpay; else -> redirect to classes login page
  handleContinue = () => {
    const { selectedServices, selectedDuration } = this.state;
    if (selectedServices.length === 0) {
      alert("Please select at least one class to continue.");
      return;
    }

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (token || userId) {
      // User is already logged in -> open checkout immediately
      this.launchRazorpayCheckout();
    } else {
      // User is not logged in -> save selection and redirect to login page for this flow
      localStorage.setItem(
        "pending_classes_checkout",
        JSON.stringify({
          services: selectedServices,
          duration: selectedDuration,
        })
      );
      this.props.history.push("/classes-login");
    }
  };

  // Launch Razorpay checkout with backend database order creation & verification
  launchRazorpayCheckout = async () => {
    const { selectedServices, selectedDuration } = this.state;
    const pricing = this.getPricing();
    const token = localStorage.getItem("token");

    const selectedNames = SERVICES.filter((s) =>
      selectedServices.includes(s.id)
    )
      .map((s) => s.name)
      .join(", ");

    const userName = localStorage.getItem("name") || "";
    const userPhone = localStorage.getItem("mobile") || "";
    const userEmail = localStorage.getItem("email") || "";

    const apiUrl = process.env.REACT_APP_API_URL || "https://d1dgpoid6t01jm.cloudfront.net";

    let backendOrderId = null;
    let apiKey = config && config.apiKey ? config.apiKey : "rzp_live_iJcBvpNpCc9E6F";

    // 1. Create order in Backend & Database
    try {
      const orderRes = await fetch(`${apiUrl}/user/create-class-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          services: selectedServices,
          duration: selectedDuration,
        }),
      });

      const orderData = await orderRes.json();
      if (orderData.success && orderData.response) {
        backendOrderId = orderData.response.order_id;
        if (orderData.response.key) apiKey = orderData.response.key;
      }
    } catch (apiErr) {
      console.warn("Backend order creation offline, proceeding with client checkout:", apiErr.message);
    }

    // 2. Open Razorpay Checkout
    const options = {
      key: apiKey,
      amount: pricing.finalPrice * 100, // in paise
      currency: "INR",
      name: "Fitfinity",
      order_id: backendOrderId || undefined,
      description: `${selectedDuration} Months Membership (${selectedNames})`,
      image: require("../../assests/fitlogo.png"),
      prefill: {
        name: userName,
        contact: userPhone,
        email: userEmail,
      },
      notes: {
        classes: selectedNames,
        duration: `${selectedDuration} Months`,
        categoriesCount: selectedServices.length,
      },
      theme: {
        color: "#fbbf24",
      },
      handler: async (response) => {
        // 3. Verify payment in backend and activate subscription in database
        if (response.razorpay_payment_id) {
          try {
            const verifyRes = await fetch(`${apiUrl}/user/verify-class-payment`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                order_id: response.razorpay_order_id || backendOrderId,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature || "manual_verify",
              }),
            });

            const verifyData = await verifyRes.json();
            if (verifyData.success) {
              alert(
                `Payment Successful & Saved to Database!\nPayment ID: ${response.razorpay_payment_id}\nSubscription for ${selectedNames} is now active.`
              );
            } else {
              alert(
                `Payment Received (ID: ${response.razorpay_payment_id}). Processing activation...`
              );
            }
          } catch (e) {
            alert(
              `Payment Successful! Payment ID: ${response.razorpay_payment_id}\nThank you for enrolling in ${selectedNames}.`
            );
          }
        }
      },
      modal: {
        ondismiss: () => {
          console.log("Razorpay checkout closed by user");
        },
      },
    };

    if (window.Razorpay) {
      const rzp = new window.Razorpay(options);
      rzp.open();
    } else {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = () => {
        const rzp = new window.Razorpay(options);
        rzp.open();
      };
      document.body.appendChild(script);
    }
  };

  render() {
    const { selectedServices, selectedDuration } = this.state;
    const pricing = this.getPricing();
    const hasSelection = selectedServices.length > 0;

    return (
      <div className="fc-page-wrapper">
        <div className="fc-container">
          {/* Top Banner */}
          <div className="fc-top-banner">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span>200,000+ Indians training with Fitfinity daily</span>
          </div>

          {/* Sub Banner */}
          <div className="fc-offer-pill">
            <span>✨</span>
            <span>Choose One or More Classes (Get a Combo Discount!)</span>
          </div>

          {/* 4 Service Cards Grid */}
          <div className="fc-cards-grid">
            {SERVICES.map((service) => {
              const isSelected = selectedServices.includes(service.id);
              return (
                <div
                  key={service.id}
                  className={`fc-service-card ${isSelected ? "selected" : ""}`}
                  style={{ backgroundImage: `url(${service.image})` }}
                  onClick={() => this.toggleService(service.id)}
                >
                  <div className="fc-card-overlay">
                    {/* Top Right Badge */}
                    <div className="fc-badge-container">
                      {isSelected ? (
                        <div className="fc-check-badge">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                        </div>
                      ) : (
                        <div className="fc-lock-badge">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect
                              x="3"
                              y="11"
                              width="18"
                              height="11"
                              rx="2"
                              ry="2"
                            />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                          </svg>
                        </div>
                      )}
                    </div>

                    {/* Bottom Details */}
                    <div className="fc-card-details">
                      <h3 className="fc-service-name">{service.name}</h3>
                      <span className="fc-service-price">
                        {(() => {
                          const p =
                            this.state.dbPlans &&
                            this.state.dbPlans.find(
                              (item) => item.service_code === service.id
                            );
                          const months = selectedDuration === 6 ? 6 : 12;
                          if (p) {
                            const price = selectedDuration === 6 ? p.six_month_price : p.yearly_price;
                            const rate =
                              Math.round(price / (months * 1.18)) ||
                              (selectedDuration === 6 ? p.monthly_rate_6m : p.monthly_rate_12m);
                            return `₹${rate}/Month`;
                          }
                          const defaultPrice = selectedDuration === 6 ? 211 : 269;
                          const defaultRate = Math.round(defaultPrice / (months * 1.18));
                          return `₹${defaultRate}/Month`;
                        })()}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Choose Duration Section (visible when >= 1 service selected) */}
          {hasSelection && (
            <div className="fc-duration-section">
              <h2 className="fc-section-title">Choose Duration</h2>

              {/* Selected Categories Tags */}
              <div className="fc-category-tags">
                {selectedServices.map((id) => {
                  const s = SERVICES.find((item) => item.id === id);
                  return (
                    <span key={id} className="fc-category-tag">
                      {s ? s.name : id}
                    </span>
                  );
                })}
              </div>

              {/* Duration Option 1: 6 Months */}
              <div
                className={`fc-duration-card ${
                  selectedDuration === 6 ? "selected" : ""
                }`}
                onClick={() => this.setState({ selectedDuration: 6 })}
              >
                <div className="fc-duration-left">
                  <div className="fc-radio-circle">
                    {selectedDuration === 6 && (
                      <div className="fc-radio-inner" />
                    )}
                  </div>
                  <div className="fc-duration-info">
                    <span className="fc-duration-name">6 Months</span>
                    <span className="fc-duration-monthly">
                      ≈ ₹{pricing.monthly6M}/month
                    </span>
                  </div>
                </div>
                <div className="fc-duration-right">
                  <span className="fc-final-price">₹{pricing.price6M}</span>
                  <span className="fc-gst-subtext">incl. 18% GST</span>
                </div>
              </div>

              {/* Duration Option 2: 12 Months (Best Value) */}
              <div
                className={`fc-duration-card ${
                  selectedDuration === 12 ? "selected" : ""
                }`}
                onClick={() => this.setState({ selectedDuration: 12 })}
              >
                <div className="fc-best-value-badge">BEST VALUE</div>
                <div className="fc-duration-left">
                  <div className="fc-radio-circle">
                    {selectedDuration === 12 && (
                      <div className="fc-radio-inner" />
                    )}
                  </div>
                  <div className="fc-duration-info">
                    <span className="fc-duration-name">12 Months ⭐</span>
                    <span className="fc-duration-monthly">
                      ≈ ₹{pricing.monthly12M}/month
                    </span>
                  </div>
                </div>
                <div className="fc-duration-right">
                  <div className="fc-price-row">
                    <span className="fc-original-price">
                      ₹{pricing.strike12M}
                    </span>
                    <span className="fc-final-price">₹{pricing.price12M}</span>
                  </div>
                  <span className="fc-save-pill">
                    ↘ Save ₹{pricing.saved12M} ({pricing.strike12M > 0 ? Math.round((pricing.saved12M / pricing.strike12M) * 100) : 36}%)
                  </span>
                  <span className="fc-gst-subtext">incl. 18% GST</span>
                </div>
              </div>

              {/* Summary Row */}
              <div className="fc-summary-row">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <path d="M16 10a4 4 0 0 1-8 0" />
                </svg>
                <span>
                  {pricing.count} categor{pricing.count > 1 ? "ies" : "y"} ×{" "}
                  {selectedDuration} months ={" "}
                  <strong>₹{pricing.finalPrice}</strong>
                </span>
              </div>

              {/* Pay Button */}
              <button
                className="fc-pay-button"
                onClick={this.handleContinue}
              >
                Pay ₹{pricing.finalPrice}
              </button>

              {/* Trust Footer */}
              <div className="fc-trust-footer">
                <div className="fc-trust-item">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#10b981"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                  <span>100% Secure • Instant Access</span>
                </div>
                <div className="fc-trust-item">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="1"
                      y="4"
                      width="22"
                      height="16"
                      rx="2"
                      ry="2"
                    />
                    <line x1="1" y1="10" x2="23" y2="10" />
                  </svg>
                  <span>UPI • Cards • Net Banking • Wallets</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(FitnessClasses);
